import { useEffect, useState } from "react";
import React from "react";
import "@css/reactDayPickerCustom.css"

function CustomDatepicker(
    {
        currentDate,
        selectedDate,
        disabled,
        setDate,
    } : {
        currentDate: Date;
        selectedDate: Date | null;
        disabled: boolean;
        setDate: (value: Date | undefined)=>void;
    }
){
    const [selected, setSelected] = useState<Date | null>(selectedDate);
    const [showDate, setShowDate] = useState<Date>(currentDate);
    const [pickerMode, setPickerMode] = useState<"year" | "month" | "day">("day");
    const [holidayDates, setHolidayDates] = useState<string[]>([]);

    function changeDate(inc: number){
        const newDate = new Date(showDate);
        newDate.setMonth(newDate.getMonth() + inc);
        setShowDate(newDate);
    }


    
    useEffect(()=>{
        setShowDate(currentDate);
    }, [currentDate])
    useEffect(()=>{

        setSelected(selectedDate);
    }, [selectedDate])

    useEffect(()=>{
        setDate(selected);
    }, [selected])
    
    return (
        <div className={`cdpContainer ${disabled? "cdpContainer--disabled" : ""}`}>
            <div className="cdp_header">
                <button type="button"
                    className="cdp_changeDateButton cdp_changeDateButton--prev"
                    onClick={() => changeDate(-1)}
                ></button>
                
                <button type="button"
                    className="cdp_currentDate"
                    // onClick={()=>{
                    //     setPickerMode("month");
                    // }}    
                >
                    {`${showDate.getFullYear()}년 ${pickerMode === "day"? showDate.getMonth()+1 + "월": ""}`}
                </button>
                <button type="button"
                    onClick={() => changeDate(1)}
                    className="cdp_changeDateButton cdp_changeDateButton--next"
                ></button>
            </div>

            <div>
                <PickerDayGrid 
                    currentDate={showDate}
                    selected={selected}
                    setSelected={setSelected}
                    holidayDates={holidayDates}
                />
            </div>
        </div>
    )
}

export default CustomDatepicker;

function PickerDayGrid({
        currentDate,
        holidayDates,
        selected,
        setSelected,
    }:{
        currentDate: Date;
        holidayDates: string[];
        selected: Date | undefined;
        setSelected: (value: Date) => void;
    }
){
    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const daysInMonth = lastDay.getDate();
    let startDay = firstDay.getDay();   // 한 주 시작 : 일
    //startDay = (startDay + 6) % 7;  // 한 주 시작 : 월

    const weeks: React.JSX.Element[][] = [];
    let currentWeek: React.JSX.Element[] = [];

    // 이전 달의 날짜들
    for (let day = 0; day < startDay; day++) {
        const prevDate = new Date(firstDay);
        prevDate.setDate(prevDate.getDate() - (startDay - day));
        const dateStr = `${prevDate.getFullYear()}-${String(prevDate.getMonth() + 1).padStart(2, '0')}-${String(prevDate.getDate()).padStart(2, '0')}`;
        const prevDay = prevDate.getDate();
        const weekend = prevDate.getDay();
        const isHoliday = holidayDates.includes(dateStr);

        const isSelected = selected? new Date(selected).toDateString() === new Date(dateStr).toDateString() : false;
        
        currentWeek.push(
            <td key={dateStr}>
                <DayButton
                    key={dateStr}
                    dateStr={dateStr}
                    thisMonth={false}
                    day={prevDay}
                    weekend={weekend}
                    isHoliday={isHoliday}
                    isSelected={isSelected}
                    setSelected={setSelected}
                />
            </td>
        );
    }
    
    // 현재 달의 날짜들
    for (let day = 1; day <= daysInMonth; day++) {
        const dateStr = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        const weekend = (day - 1 + startDay) % 7;
        const isHoliday = holidayDates.includes(dateStr);

        const isSelected = selected? new Date(selected).toDateString() === new Date(dateStr).toDateString() : false;
        
        currentWeek.push(
            <td key={dateStr}>
                <DayButton
                    key={dateStr}
                    dateStr={dateStr}
                    thisMonth={true}
                    day={day}
                    weekend={weekend}
                    isHoliday={isHoliday}
                    isSelected={isSelected}
                    setSelected={setSelected}
                />
            </td>
        );

        if (currentWeek.length === 7) {
            weeks.push(currentWeek);
            currentWeek = [];
        }
    }

    // 다음 달의 날짜들
    const remainingCells = 7 - currentWeek.length;
    if (remainingCells > 0) {
        for (let i = 0; i < remainingCells; i++) {
            const nextMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, i + 1);
            const dateStr = `${nextMonthDate.getFullYear()}-${String(nextMonthDate.getMonth() + 1).padStart(2, '0')}-${String(nextMonthDate.getDate()).padStart(2, '0')}`;
            const isHoliday = holidayDates.includes(dateStr);
            const weekend = nextMonthDate.getDay();
            const isSelected = selected? new Date(selected).toDateString() === new Date(dateStr).toDateString() : false;
            
            currentWeek.push(
                <td key={dateStr}>
                    <DayButton
                        key={dateStr}
                        dateStr={dateStr}
                        thisMonth={false}
                        day={nextMonthDate.getDate()}
                        weekend={weekend}
                        isHoliday={isHoliday}
                        isSelected={isSelected}
                        setSelected={setSelected}
                    />
                </td>
            );
        }
        weeks.push(currentWeek);
    }

    return(
        <table>
            <thead>
                <tr>
                    <th className="cdpTh">일</th>
                    <th className="cdpTh">월</th>
                    <th className="cdpTh">화</th>
                    <th className="cdpTh">수</th>
                    <th className="cdpTh">목</th>
                    <th className="cdpTh">금</th>
                    <th className="cdpTh">토</th>
                </tr>
            </thead>
            <tbody>
                {weeks.map((week, idx) => (
                    <tr key={idx}>{week}</tr>
                ))}
            </tbody>
        </table>
    )
}

function DayButton(
    {
        dateStr,
        thisMonth,
        day,
        weekend,
        isHoliday,
        isSelected,
        setSelected,
    } : {
        dateStr: string;
        thisMonth: boolean;
        day: number;
        weekend: number;
        isHoliday: boolean;
        isSelected: boolean;
        setSelected: (value: Date|undefined) => void;
    }
){
    const isHol = weekend === 6 ? "sat" : weekend === 0 ? "sun" : isHoliday ? "hol" : "";
    const isThisMonth = thisMonth ? "" : "otherMonth";
    const selected = isSelected ? "selected" : "";
    
    return(
        <div
            className="DayButtonCell"
            data-date={dateStr}
        >
            <button
                className={`${isThisMonth} ${isHol} ${selected}`}
                onClick={() => {
                    setSelected(selected? undefined : new Date(dateStr));
                }}
            >
                {day}
            </button>
        </div>
    )
}